/**
 * @author: theralytics
 * @uses: To show header data
 * @desc: Notification commented intentionally for further use(*-Do not remove).
 */


import React, { Component } from 'react';
import AvatarDropdown from '../components/avatarDropdown.js';
import { connect } from 'react-redux';
// import { getAppConfigList } from '../modules/AppConfig/actions';
// import Notification from './notification.js';
// import MenuItem from 'material-ui/MenuItem';
// import history from '../history';
import GlobalVariables from '../actions/utilAction';
import avatarImage from '../img/doctor.png';
// const names = [
//   'Alaska',
//   'California',
//   'Florida',
//   'New York',
//   'Washington',
//   'Ontario',
// ];
class PatientPortalHeader extends Component {

  // constructor(props) {
  //   super(props);
  //   // this.state = {
  //   //   values: [],
  //   //   //locations: [],
  //   // };
  //   // this.handleNewRequest = this.handleNewRequest.bind(this);
  // }

  componentWillMount() {
    // debugger
    // this.props.getAppConfigList();
    // this.props.getUserLocations(this.props.loginUserInfo.id);

  }

  componentWillReceiveProps(nextProps) {
    // if (this.props.userMaster && this.props.userMaster.masterLocation && this.props.userLocations) {

    //   let loc = [];
    //   this.props.userMaster.masterLocation.map((masterLoc) => {
    //     return this.props.userLocations.find((userLoc) => {
    //       if (userLoc.LocationID === masterLoc.id) {
    //         loc.push(masterLoc);
    //       }
    //       return loc;
    //     });
    //   });
    //   if (loc.length) {
    //     this.setState({ locations: loc });
    //   }
    // }
    GlobalVariables.PageSize = nextProps.pageSize;
    // if (nextProps.locationId && this.props.locationId !== nextProps.locationId) {
    //   GlobalVariables.CurrentLocationId = nextProps.locationId;
    //   // this.props.changeLocationAction(nextProps.locationId, this.props.loginUserInfo);
    //   // this.props.getPatientsByFirstCharacter('startwith', 'A', '', nextProps.locationId);
    // }
  }

  // handleChange = (event, index, values) => {
  //   this.setState({ values });
  // };

  // handleNewRequest = (input, selectedRecord) => {
  //   input.onChange(selectedRecord.value);
  //   GlobalVariables.CurrentLocationId = selectedRecord.value;
  //   this.props.changeLocationAction(selectedRecord.value, this.props.loginUserInfo);
  //   this.props.getPatientsByFirstCharacter('startwith', 'A', '', selectedRecord.value);
  //   history.push('/client-dashboard');
  // }

  // menuItems(values) {
  //   if (names.length) {
  //     return names.map((name) => (
  //       <MenuItem
  //         key={name}
  //         insetChildren={true}
  //         checked={values && values.indexOf(name) > -1}
  //         value={name}
  //         primaryText={name}
  //       />
  //     ));
  //   }
  // }
  render() {
    const style = {
      background: this.props.colorHeaderBanner.color     
    };
    let userImage = avatarImage
      , welcomeNote = 'Welcome, ' + (this.props.loginUserInfo.firstName + ' ' + this.props.loginUserInfo.lastName);

    // const { values } = this.state;
    return (
      <header style={style} className="an-header">
        <div className="header-right">
          {/* <Notification/>*/}
          <div className="welcomeName">{welcomeNote}</div>
          <AvatarDropdown userImage={userImage} welcomeNote={welcomeNote} />
        </div>
      </header>
    );
  }
}

function mapStateToProps(state) {

  // let currentLocationId = state.login.currentLocationId > 0 ? state.login.currentLocationId : state.user.currentLocationId
  // state.login.currentLocationId = currentLocationId

  let initialData = {
    Location: state.login.currentLocationId,
  };

  // let app_config = state.appConfig.appConfigList;
  // let pageSize = GlobalVariables.PageSize;

  // if (app_config && app_config.data) {
  //   app_config.data.map((Obj) => {
  //     if (Obj.attributes.ConfigType === 2) {
  //       switch (Obj.attributes.Key) {
  //         case 'PAGE_SIZE':
  //           return pageSize = Obj.attributes.Value;
  //           break;
  //       }
  //     }
  //   });
  // }

  //console.log('state.superadminLogin.loginUserInfo.........',state.superadminLogin.loginUserInfo);
  return {
    initialValues: initialData,
    colorHeaderBanner: state.headerBAnnerActiveStyle,
    // patientMaster: state.patient.master_data,
    // userMaster: state.user.master_data,
    // userLocations: state.user.userLocations,
    // staffList: state.user.staffList,
    // userLocationList: state.user.userLocationList,
    loginUserInfo: state.superadminLogin.loginUserInfo,
    pageSize: 10,
    // locationId: state.user.currentLocationId,
  };
}

// PatientPortalHeader = reduxForm({
//   form: 'HeaderForm',
//   enableReinitialize: true,
// })(PatientPortalHeader);

export default connect(mapStateToProps, null)(PatientPortalHeader);



// WEBPACK FOOTER //
// ./src/containers/super-admin-header.js